import React, { useState } from 'react';
import ScreeningResultsIcon from '../../../assets/icons/screeningResultsIcon.svg';
import InfoIcon from '../../../assets/icons/infoIcon.svg';
import { TypographyStyledBlack } from '../../../shared/components/tileLinkStyled/style';
import { Box, Button, IconButton } from '@mui/material';
import { BlueHeaderWithText } from '../../estimatingRequirements/peng2018/blueHeaderWithText';
import { TypographyH4White } from '../style';
import { metaDataSelector } from '../../../store/globalSelectors';
import { useAppSelector } from '../../../store/hooks';
import { NavigationButtons } from '../../../shared/components/navigationButtons';
import { InfoModal } from '../../../shared/components/modal/InfoModal';

export const ScreeningResults = () => {
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const { muscleScreening } = useAppSelector(metaDataSelector);
  const { sarcf } = muscleScreening;
  const { totalScore } = sarcf;

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          backgroundColor: '#F2F2F2',
          p: 0,
          top: 0,
          left: 0,
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: '1.875rem',
            flexGrow: 1
          }}
        >
          <Box
            sx={{
              backgroundColor: '#fff',
              height: '100px',
              width: '100px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <img alt="Screening Result Icon" src={ScreeningResultsIcon} />
          </Box>

          <TypographyStyledBlack sx={{ margin: '3.125rem 0' }}>
            SCREENING RESULTS
          </TypographyStyledBlack>

          <IconButton
            onClick={() => setOpenInfoModal(true)}
            size="small"
            aria-label="info"
            data-testid={'screening-result-icon-id'}
            sx={{
              position: 'absolute',
              right: '1.25rem', // Floats to the right
              top: 0,
              transform: 'translateY(-50%)' // Vertically centers the button
            }}
          >
            <img src={InfoIcon} alt="Info" width="20" height="20" />
          </IconButton>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              marginBottom: '1.25rem'
            }}
          >
            <BlueHeaderWithText
              text1={'Total Score:'}
              value1={String(totalScore)}
              single={true}
              customWidth="75%"
              customMarginBottom="1rem"
            />
          </Box>
          <Box
            sx={{
              width: '80%',
              backgroundColor: '#fff',
              border: '0.125rem solid #002A3A',
              borderRadius: '0.9375rem',
              padding: '0.9375rem',
              fontFamily: 'BGRegular',
              textAlign: 'center'
            }}
          >
            SARC-F score ≥4 may indicate <strong>low muscle mass.</strong>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'bottom',
            mb: '0.625rem',
            mt: 2
          }}
        >
          <NavigationButtons nextRoute={'/summary'} nextDisabled={false} />
        </Box>
      </Box>

      <InfoModal
        open={openInfoModal}
        onClose={() => setOpenInfoModal(false)}
        title={'Reference: '}
        content={'Malmstrom T.K. Morley M. JAMDA. 2013; 14(8):531-532.'}
      />
    </>
  );
};
